module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-193.5701898.woff2";